export const DEAL_SYNERGY_CLOSEOUT_TASK_PREFIX = 'system:deal-synergy-closeout:';

export const DEAL_SYNERGY_CLOSEOUT_ACTIONS = [
  'thank',
  'compensate_invoice',
  'invite',
  'other',
  'not_needed',
] as const;

export type DealSynergyCloseoutAction = typeof DEAL_SYNERGY_CLOSEOUT_ACTIONS[number];

const CLOSEOUT_ACTION_LABELS: Record<DealSynergyCloseoutAction, string> = {
  thank: 'Ringraziamento',
  compensate_invoice: 'Compenso o fattura',
  invite: 'Invito',
  other: 'Altra azione',
  not_needed: 'Nessuna azione necessaria',
};

export function dealSynergyCloseoutTaskKey(dealId: number, synergyId: number): string {
  return `${DEAL_SYNERGY_CLOSEOUT_TASK_PREFIX}${dealId}:${synergyId}`;
}

export function isDealSynergyCloseoutTaskKey(value: unknown): boolean {
  return typeof value === 'string' && value.startsWith(DEAL_SYNERGY_CLOSEOUT_TASK_PREFIX);
}

export function parseDealSynergyCloseoutAction(value: unknown): DealSynergyCloseoutAction | null {
  return typeof value === 'string' && DEAL_SYNERGY_CLOSEOUT_ACTIONS.includes(value as DealSynergyCloseoutAction)
    ? value as DealSynergyCloseoutAction
    : null;
}

export function dealSynergyCloseoutActionLabel(action: DealSynergyCloseoutAction): string {
  return CLOSEOUT_ACTION_LABELS[action];
}
